module.exports = __webpack_public_path__ + "static/media/empty-fields.de8033a3.svg";